export const defaultNumberOfPrestationsToShow_Desktop = 10
export const defaultNumberOfPrestationsToShow_Mobile = 5
export const additionalNumberOfPrestationsToShow_Desktop = 10
export const additionalNumberOfPrestationsToShow_Mobile = 5